import React, { useState } from 'react'
import Emails from 'components/QuestionnaireRequest/AdminNew/Tabs/Admins/Emails'
import { useDispatch, useSelector } from 'react-redux'
import { setAdminEmails } from 'components/QuestionnaireRequest/AdminNew/store/slice'

export default function QuestionnaireAdminTabAdmins(props) {
  const dispatch = useDispatch()
  const { adminEmails } = useSelector((state) => state.organizationQuestionnaireAdmin)

  return (
    <div style={{ marginTop: 30 }}>
      <div className="questionnaire-admin-general-table-container">
        <Emails
          organizationId={props.organization.id}
          adminEmails={adminEmails}
          updateAdminEmails={(adminEmails) => dispatch(setAdminEmails(adminEmails))}
        />
      </div>
    </div>
  )
}
